const entryFiles = {
    es6bundle: './editorial/index.js',
    moduleloader: './editorial/init.js',
    corebundle: './core/index.js',
    corebundlelegacy: './core/indexLegacy.js',
    escomponentbundle: './component/index.js',
    serviceplanbundle: './service_plan/index.js',
    serviceplansharedstyles: './_shared/service_plan/index.js',
    bas2bundle: './bas_2/index.js',
    batd2bundle: './batd_2/index.js',
    batdsharedstyles: './_shared/batd_common/index.js',
    fad2bundle: './fad_2/index.js',
    fad2details: './fad_2/details/index.js',
    portalbundle: './portal/index.js',
    formbuilder2bundle: './form_builder_2/index.js',
    formbuilder2styles: './_shared/form_builder_2/index.js',
    emissiongraphbundle: './emission_graph/index.js',
    myaccountbundle: './my_account/index.js',
    configurator360bundle: './configurator_360/index.js',
    configurator360flatbundle: './configurator_360_flat/index.js',
    saveforlaterspabundle: './save_for_later/spa.js',
    saveforlaterutilbundle: './save_for_later/util.js',
    contexthubenable: './utils/contexthub-enable.js',
    contexthubdisable: './utils/contexthub-disable.js',
    contexthubpreinit: './utils/contexthub-preinit.js',
    datalayerhelper: './utils/datalayer-helper.js',
    configurator2bundle: './configurator_2/index.js',
    myaccount2utilbundle: './my_account_2/util/index.js',
    myaccount2spabundle: './my_account_2/spa/index.js',
    digitalservicerecordbundle:
        './my_account_2/spa/views/digital-service-record/index.js',
    carcheckout: './car_checkout/index.js',
    ordercancellationform: './order_cancellation_form/index.js',
    scrolltohash: './utils/scroll-to-hash.js',
    financeapplicationspabundle: './finance_application/index.js',
    carcompare2: './car_compare_2/index.js',
};

// This list is not used anywhere, references of items from this list are added as copy to .jsp in components backend code
const editorialModuleList = [
    'hybrid_video',
    'hybrid_video_youtube',
    'heading_box',
    'product_grid',
    'versatile_carousel',
    'offers',
    'image_tile_carousel',
    'similar_product_swiper',
    'video_overlay',
    'image_tile_4_up',
    'xl_tile_lite',
    '4col_image_layout',
    'disclaimer_box',
    'video_player',
    'tabular_module',
    'compare_table',
    'discover_more',
    'image_timeline',
    'sticky_navbar',
    'popular_configurations',
    'inpage_dealer_search',
    'brochure_range',
    'find_yours_lite',
    'section_intro_module',
    'comparision_slider',
    'audio_lite',
    'gallery_lite',
    'featured_articles',
    'content_hub_50_50',
    'content_hub_lite',
    'help_me_choose',
    'help_me_choose_bike',
    'next_previous_articles',
    'body_copy_module',
    'content_hub_iframe',
    'content_hub_image_copy_overlay',
    'article_details_lite',
    'blog_cross_linking',
    'article_list',
    'feature_article_list',
    'dsr_videos',
    'user_like_chat',
    'car_specs_glance',
    'car_specs_summary',
    'car_specs_visualiser',
    'hero-tile',
    'features_carousel',
    'gallery_module',
    'four_specs',
    'linkbar-module',
    'scroll-nudge',
    'secondary_contextual_links',
    'features_content_layout',
    'dual_formbuilder',
    'list_check_bullet',
    'modal_popup',
    'accordian_list',
    'feature_stack',
    'scroll_carousel_accordion',
    'configurator_back_link',
    'sketchfab_viewer',
    'order_cancellation',
];

const componentList = [
    {
        name: 'inline_svg',
        loadType: 'onWindowLoad',
        queryString: '.svg-icon:not(.replaced-svg)',
    },
    {
        name: 'waypoint_initializer',
        loadType: 'onDomLoad',
        queryString: '[data-action="waypointTrigger"]',
    },
];

module.exports = {
    entryFiles,
    editorialModuleList,
    componentList,
};
